import { Injectable } from '@angular/core';

@Injectable({
    providedIn: "root"
})
export abstract class ClientToastController {
    abstract displayToast(message: string, duration: number);
}